import React from "react";
import styled from "styled-components";
import KlaytnImage from "../assets/icon/Klaytn.svg";
import OzysImage from "../assets/icon/ozys.svg";
import { useInView } from "react-intersection-observer";
import {
  animated,
  useChain,
  useSpring,
  useSpringRef,
  useTransition,
} from "react-spring";
import Title from "./Title";
import { device } from "../styles/media-query";
import { useMyMediaQuery } from "../hooks/useMediaQuery";

const Container = styled.section`
  ${device.tablet} {
    padding: 12rem 6rem;
  }
  ${device.mobile} {
    padding: 8rem 2rem;
  }
  ${device.desktop} {
    padding: 20rem 4rem;
    max-width: 1080px;
    margin: 0 auto;
  }
`;

const PartnerList = styled.ul`
  display: flex;
  ${device.desktop} {
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
  }
  flex-direction: column;

  margin-top: 8rem;
  ${device.tablet} {
    margin-top: 6rem;
  }
`;

const PartnerImage = styled.img`
  height: 12rem;
  ${device.desktop} {
    margin-bottom: 0;
  }
  margin-bottom: 6rem;
`;

const ComingSoon = styled.span`
  color: white;
  font-size: 20px;
  text-align: center;
`;

function Partners() {
  const { isDesktop } = useMyMediaQuery();
  const { ref, inView } = useInView({
    rootMargin: "240px 0px 0px 0px",
    triggerOnce: true,
  });

  const animationStyle = useSpring({
    delay: 200,
    to: {
      transform: inView ? "translateY(0px)" : "translateY(30px)",
      opacity: inView ? 1 : 0,
    },
    config: { duration: 500 },
  });

  const transitionRef = useSpringRef();
  const transitions = useTransition([KlaytnImage, OzysImage, "Coming soon"], {
    ref: transitionRef,
    from: { opacity: 0, transform: "translateY(30px)" },
    enter: { opacity: 1, transform: "translateY(0px)" },
    trail: 400,
    delay: 200,
  });

  useChain(inView ? [transitionRef] : []);

  return (
    <Container id={"partners"}>
      <animated.div style={animationStyle}>
        <Title text={"Partners"} />
        <PartnerList ref={ref}>
          {transitions((style, item) => (
            <animated.li
              style={{ ...style, margin: !isDesktop ? "0 auto" : "" }}
            >
              {item === "Coming soon" ? (
                <ComingSoon>Coming soon</ComingSoon>
              ) : (
                <PartnerImage src={item} alt={"partner"} />
              )}
            </animated.li>
          ))}
        </PartnerList>
      </animated.div>
    </Container>
  );
}

export default Partners;
